/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseDataResponse_DayOffApplicationFileUrlResponse_ } from '../models/BaseDataResponse_DayOffApplicationFileUrlResponse_';
import type { BaseDataResponse_DayOffApplicationResponse_ } from '../models/BaseDataResponse_DayOffApplicationResponse_';
import type { BaseDataResponse_DayOffTemplateFileResponse_ } from '../models/BaseDataResponse_DayOffTemplateFileResponse_';
import type { BaseListDataResponse_DayOffApplicationResponse_ } from '../models/BaseListDataResponse_DayOffApplicationResponse_';
import type { Body_upload_temp_file_api_vacation_day_off_applications_upload_temp_post } from '../models/Body_upload_temp_file_api_vacation_day_off_applications_upload_temp_post';
import type { CreateMyDayOffApplicationRequest } from '../models/CreateMyDayOffApplicationRequest';
import type { DayOffApplicationStatus } from '../models/DayOffApplicationStatus';
import { DayOffApplicationType } from '../models/DayOffApplicationType';
import type { UpdateDayOffApplicationDatesRequest } from '../models/UpdateDayOffApplicationDatesRequest';
import type { UploadDayOffOrderRequest } from '../models/UploadDayOffOrderRequest';
import type { UploadDayOffSignedOrderRequest } from '../models/UploadDayOffSignedOrderRequest';
import type { UploadMyDayOffSignedOrderRequest } from '../models/UploadMyDayOffSignedOrderRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DayOffApplicationsService {
    /**
     * List My Day Off Applications
     * Получение списка своих заявок на выходной
     * @param status Фильтр по типу выходного
     * @param limit Лимит
     * @param offset Смещение
     * @returns BaseListDataResponse_DayOffApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static listMyDayOffApplicationsApiVacationDayOffApplicationsMeGet(
        status?: (DayOffApplicationType | null),
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<BaseListDataResponse_DayOffApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/day-off-applications/me',
            query: {
                'status': status,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Create My Day Off Application
     * Создание заявки на выходной от имени текущего пользователя
     * @param requestBody
     * @returns BaseDataResponse_DayOffApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static createMyDayOffApplicationApiVacationDayOffApplicationsMePost(
        requestBody: CreateMyDayOffApplicationRequest,
    ): CancelablePromise<BaseDataResponse_DayOffApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/day-off-applications/me',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get My Day Off Application
     * Получение своей заявки на выходной по ID
     * @param applicationId
     * @returns BaseDataResponse_DayOffApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static getMyDayOffApplicationApiVacationDayOffApplicationsMeApplicationIdGet(
        applicationId: string,
    ): CancelablePromise<BaseDataResponse_DayOffApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/day-off-applications/me/{application_id}',
            path: {
                'application_id': applicationId,
            },
            errors: {
                401: `Code: authentication_error`,
                404: `Code: day_off_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get My Day Off Application File Url
     * Получение временной ссылки на файл своей заявки на выходной
     * @param applicationId
     * @param expiresIn Время действия ссылки в секундах
     * @returns BaseDataResponse_DayOffApplicationFileUrlResponse_ Successful Response
     * @throws ApiError
     */
    public static getMyDayOffApplicationFileUrlApiVacationDayOffApplicationsMeApplicationIdFileUrlGet(
        applicationId: string,
        expiresIn: number = 3600,
    ): CancelablePromise<BaseDataResponse_DayOffApplicationFileUrlResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/day-off-applications/me/{application_id}/file-url',
            path: {
                'application_id': applicationId,
            },
            query: {
                'expires_in': expiresIn,
            },
            errors: {
                400: `Code: day_off_application_not_file`,
                401: `Code: authentication_error`,
                404: `Code: day_off_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get My Day Off Order File Url
     * Получение временной ссылки на неподписанный приказ своей заявки на выходной
     * @param applicationId
     * @param expiresIn Время действия ссылки в секундах
     * @returns BaseDataResponse_DayOffApplicationFileUrlResponse_ Successful Response
     * @throws ApiError
     */
    public static getMyDayOffOrderFileUrlApiVacationDayOffApplicationsMeApplicationIdOrderUrlGet(
        applicationId: string,
        expiresIn: number = 3600,
    ): CancelablePromise<BaseDataResponse_DayOffApplicationFileUrlResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/day-off-applications/me/{application_id}/order-url',
            path: {
                'application_id': applicationId,
            },
            query: {
                'expires_in': expiresIn,
            },
            errors: {
                400: `Code: day_off_application_not_file`,
                401: `Code: authentication_error`,
                404: `Code: day_off_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get My Day Off Signed Order File Url
     * Получение временной ссылки на подписанный приказ своей заявки на выходной
     * @param applicationId
     * @param expiresIn Время действия ссылки в секундах
     * @returns BaseDataResponse_DayOffApplicationFileUrlResponse_ Successful Response
     * @throws ApiError
     */
    public static getMyDayOffSignedOrderFileUrlApiVacationDayOffApplicationsMeApplicationIdSignedOrderUrlGet(
        applicationId: string,
        expiresIn: number = 3600,
    ): CancelablePromise<BaseDataResponse_DayOffApplicationFileUrlResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/day-off-applications/me/{application_id}/signed-order-url',
            path: {
                'application_id': applicationId,
            },
            query: {
                'expires_in': expiresIn,
            },
            errors: {
                400: `Code: day_off_application_not_file`,
                401: `Code: authentication_error`,
                404: `Code: day_off_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Upload My Day Off Signed Order
     * Загрузка подписанного приказа на выходной от имени текущего пользователя
     * @param applicationId
     * @param requestBody
     * @returns BaseDataResponse_DayOffApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static uploadMyDayOffSignedOrderApiVacationDayOffApplicationsMeApplicationIdSignedOrderPost(
        applicationId: string,
        requestBody: UploadMyDayOffSignedOrderRequest,
    ): CancelablePromise<BaseDataResponse_DayOffApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/day-off-applications/me/{application_id}/signed-order',
            path: {
                'application_id': applicationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                404: `Code: day_off_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Confirm My Day Off
     * Подтверждение Day Off текущим пользователем
     * @param applicationId
     * @returns BaseDataResponse_DayOffApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static confirmMyDayOffApiVacationDayOffApplicationsMeApplicationIdConfirmPost(
        applicationId: string,
    ): CancelablePromise<BaseDataResponse_DayOffApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/day-off-applications/me/{application_id}/confirm',
            path: {
                'application_id': applicationId,
            },
            errors: {
                400: `Code: day_off_application_already_confirmed`,
                401: `Code: authentication_error`,
                404: `Code: day_off_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Cancel My Day Off
     * Отмена Day Off текущим пользователем
     * @param applicationId
     * @returns BaseDataResponse_DayOffApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static cancelMyDayOffApiVacationDayOffApplicationsMeApplicationIdCancelPost(
        applicationId: string,
    ): CancelablePromise<BaseDataResponse_DayOffApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/day-off-applications/me/{application_id}/cancel',
            path: {
                'application_id': applicationId,
            },
            errors: {
                400: `Code: day_off_application_already_confirmed`,
                401: `Code: authentication_error`,
                404: `Code: day_off_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Upload Temp File
     * Загрузка временного файла. Файл автоматически удалится через 10 минут.
     * @param formData
     * @returns BaseDataResponse_DayOffApplicationFileUrlResponse_ Successful Response
     * @throws ApiError
     */
    public static uploadTempFileApiVacationDayOffApplicationsUploadTempPost(
        formData: Body_upload_temp_file_api_vacation_day_off_applications_upload_temp_post,
    ): CancelablePromise<BaseDataResponse_DayOffApplicationFileUrlResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/day-off-applications/upload-temp',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get Day Off Application Template
     * Получение шаблона заявления на выходной
     * @param type Тип выходного (paid/unpaid)
     * @returns BaseDataResponse_DayOffTemplateFileResponse_ Successful Response
     * @throws ApiError
     */
    public static getDayOffApplicationTemplateApiVacationDayOffApplicationsTemplateGet(
        type: DayOffApplicationType = DayOffApplicationType.PAID,
    ): CancelablePromise<BaseDataResponse_DayOffTemplateFileResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/day-off-applications/template',
            query: {
                'type': type,
            },
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * List Day Off Applications
     * Получение списка заявок на выходной с фильтрацией
     * @param status Фильтр по статусу
     * @param userId Фильтр по ID пользователя
     * @param userSearch Поиск по username, email или full_name (частичное совпадение)
     * @param applicationType Фильтр по типу выходного
     * @param limit Лимит
     * @param offset Смещение
     * @returns BaseListDataResponse_DayOffApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static listDayOffApplicationsApiVacationDayOffApplicationsGet(
        status?: (DayOffApplicationStatus | null),
        userId?: (string | null),
        userSearch?: (string | null),
        applicationType?: (DayOffApplicationType | null),
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<BaseListDataResponse_DayOffApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/day-off-applications',
            query: {
                'status': status,
                'user_id': userId,
                'user_search': userSearch,
                'application_type': applicationType,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get Day Off Application
     * Получение заявки на выходной по ID
     * @param applicationId
     * @returns BaseDataResponse_DayOffApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static getDayOffApplicationApiVacationDayOffApplicationsApplicationIdGet(
        applicationId: string,
    ): CancelablePromise<BaseDataResponse_DayOffApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/day-off-applications/{application_id}',
            path: {
                'application_id': applicationId,
            },
            errors: {
                401: `Code: authentication_error`,
                404: `Code: day_off_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get Day Off Application File Url
     * Получение временной ссылки на файл заявки на выходной
     * @param applicationId
     * @param expiresIn Время действия ссылки в секундах
     * @returns BaseDataResponse_DayOffApplicationFileUrlResponse_ Successful Response
     * @throws ApiError
     */
    public static getDayOffApplicationFileUrlApiVacationDayOffApplicationsApplicationIdFileUrlGet(
        applicationId: string,
        expiresIn: number = 3600,
    ): CancelablePromise<BaseDataResponse_DayOffApplicationFileUrlResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/day-off-applications/{application_id}/file-url',
            path: {
                'application_id': applicationId,
            },
            query: {
                'expires_in': expiresIn,
            },
            errors: {
                400: `Code: day_off_application_not_file`,
                401: `Code: authentication_error`,
                404: `Code: day_off_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Update Day Off Application Dates Endpoint
     * Обновление дат в заявке на выходной
     * @param applicationId
     * @param requestBody
     * @returns BaseDataResponse_DayOffApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static updateDayOffApplicationDatesEndpointApiVacationDayOffApplicationsApplicationIdDatesPut(
        applicationId: string,
        requestBody: UpdateDayOffApplicationDatesRequest,
    ): CancelablePromise<BaseDataResponse_DayOffApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/vacation/day-off-applications/{application_id}/dates',
            path: {
                'application_id': applicationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Code: invalid_day_off_application_dates`,
                401: `Code: authentication_error`,
                404: `Code: day_off_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Send Dayoff Planned Notification Endpoint
     * Отправка нотификации пользователю о запланированном Day Off.
     *
     * Нотификация отправляется в Telegram с inline кнопками: Пойду, Отменю.
     * @param applicationId
     * @returns void
     * @throws ApiError
     */
    public static sendDayoffPlannedNotificationEndpointApiVacationDayOffApplicationsApplicationIdNotifyPlannedPost(
        applicationId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/day-off-applications/{application_id}/notify-planned',
            path: {
                'application_id': applicationId,
            },
            errors: {
                400: `Code: invalid_day_off_application_dates`,
                401: `Code: authentication_error`,
                404: `Code: day_off_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Upload Day Off Order Endpoint
     * Загрузка приказа на Day Off (бухгалтером)
     * @param applicationId
     * @param requestBody
     * @returns BaseDataResponse_DayOffApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static uploadDayOffOrderEndpointApiVacationDayOffApplicationsApplicationIdOrderPost(
        applicationId: string,
        requestBody: UploadDayOffOrderRequest,
    ): CancelablePromise<BaseDataResponse_DayOffApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/day-off-applications/{application_id}/order',
            path: {
                'application_id': applicationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                404: `Code: day_off_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Upload Day Off Signed Order Endpoint
     * Загрузка подписанного приказа на Day Off (бухгалтером)
     * @param applicationId
     * @param requestBody
     * @returns BaseDataResponse_DayOffApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static uploadDayOffSignedOrderEndpointApiVacationDayOffApplicationsApplicationIdSignedOrderPost(
        applicationId: string,
        requestBody: UploadDayOffSignedOrderRequest,
    ): CancelablePromise<BaseDataResponse_DayOffApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/day-off-applications/{application_id}/signed-order',
            path: {
                'application_id': applicationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                404: `Code: day_off_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Revert Day Off To Order Signing Endpoint
     * Возврат заявки на выходной к статусу order_signing
     * @param applicationId
     * @returns BaseDataResponse_DayOffApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static revertDayOffToOrderSigningEndpointApiVacationDayOffApplicationsApplicationIdRevertToOrderSigningPost(
        applicationId: string,
    ): CancelablePromise<BaseDataResponse_DayOffApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/day-off-applications/{application_id}/revert-to-order-signing',
            path: {
                'application_id': applicationId,
            },
            errors: {
                401: `Code: authentication_error`,
                404: `Code: day_off_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get Day Off Order File Url
     * Получение временной ссылки на приказ Day Off
     * @param applicationId
     * @param expiresIn Время действия ссылки в секундах
     * @returns BaseDataResponse_DayOffApplicationFileUrlResponse_ Successful Response
     * @throws ApiError
     */
    public static getDayOffOrderFileUrlApiVacationDayOffApplicationsApplicationIdOrderUrlGet(
        applicationId: string,
        expiresIn: number = 3600,
    ): CancelablePromise<BaseDataResponse_DayOffApplicationFileUrlResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/day-off-applications/{application_id}/order-url',
            path: {
                'application_id': applicationId,
            },
            query: {
                'expires_in': expiresIn,
            },
            errors: {
                400: `Code: day_off_application_not_file`,
                401: `Code: authentication_error`,
                404: `Code: day_off_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get Day Off Signed Order File Url
     * Получение временной ссылки на подписанный приказ Day Off
     * @param applicationId
     * @param expiresIn Время действия ссылки в секундах
     * @returns BaseDataResponse_DayOffApplicationFileUrlResponse_ Successful Response
     * @throws ApiError
     */
    public static getDayOffSignedOrderFileUrlApiVacationDayOffApplicationsApplicationIdSignedOrderUrlGet(
        applicationId: string,
        expiresIn: number = 3600,
    ): CancelablePromise<BaseDataResponse_DayOffApplicationFileUrlResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/day-off-applications/{application_id}/signed-order-url',
            path: {
                'application_id': applicationId,
            },
            query: {
                'expires_in': expiresIn,
            },
            errors: {
                400: `Code: day_off_application_not_file`,
                401: `Code: authentication_error`,
                404: `Code: day_off_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
}
